declare global {
	interface Window {
		gtag?: (...args: unknown[]) => void
		googleAdsConfig?: {
			adsId?: string
			contactConversionLabel?: string
			phoneConversionLabel?: string
		}
	}
}

export function trackConversion(label: string | null | undefined) {
	if (typeof window === 'undefined') return
	const adsId = window.googleAdsConfig?.adsId
	if (!adsId || !label || !window.gtag) return
	window.gtag('event', 'conversion', {
		send_to: `${adsId}/${label}`,
	})
}
